module.exports = new __parcel__URL__("puppy3.b1a61ea7.png").toString();